import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Button from 'components/CustomButtons/Button.js';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { AccountBalanceWallet, Close } from '@material-ui/icons';
import stylesForm from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

const useStyles = makeStyles({
  ...stylesForm,
  grid: {
    fontWeight: 'bold',
    textAlign: 'end'
  }
});

export default WithApp(function Transfer(props) {
  const classes = useStyles();
  const formRef = useRef();

  const { type, amountPay, dataPayment, methodPay, handleMethod, processPayment, accounts } = props;

  return (
    <>
      <GridItem xs={10}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleMethod('TR', true);
            processPayment(type, formRef);
          }}
          ref={formRef}
          id="formTR"
        >
          <GridContainer>
            <GridItem xs={12} md={3} lg={3}>
              <FormControl fullWidth size="small" margin="normal" disabled={methodPay.TR}>
                <InputLabel>Cuenta de mayor</InputLabel>
                <Select
                  required={true}
                  MenuProps={{
                    className: classes.selectMenu
                  }}
                  inputProps={{
                    name: 'TrsfrAcct'
                  }}
                  defaultValue={dataPayment?.TR?.TrsfrAcct || ''}
                >
                  {accounts?.map((item, i) => {
                    return (
                      <MenuItem value={item.GLAccount} key={i}>
                        {`${!!item.City ? item.City + ' - ' : ''}${item.BankName} - ${item.Branch}`}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xs={12} md={3} lg={3}>
              <TextField
                label="Fecha transferencia"
                type="date"
                name="TrsfrDate"
                fullWidth
                defaultValue={dataPayment?.TR?.TrsfrDate || moment().format('YYYY-MM-DD')}
                margin="normal"
                required
                inputProps={{ max: moment().format('YYYY-MM-DD') }}
                disabled={methodPay.TR}
              />
            </GridItem>
            <GridItem xs={12} md={3} lg={3}>
              <TextField
                label="Referencia"
                type="number"
                name="TrsfrRef"
                fullWidth
                defaultValue={dataPayment?.TR?.TrsfrRef || ''}
                margin="normal"
                required
                inputProps={{
                  min: 0
                }}
                disabled={methodPay.TR}
              />
            </GridItem>
            <GridItem xs={12} md={3} lg={3} className={classes.grid}>
              <TextField
                key={amountPay}
                name="TrsfrSum"
                fullWidth
                label="Monto a pagar"
                type="number"
                defaultValue={dataPayment?.TR?.TrsfrSum || amountPay.toFixed(2) || ''}
                margin="normal"
                onKeyPress={(e) => {
                  var key = window.event ? e.which : e.keyCode;
                  if (key === 101) {
                    return e.preventDefault();
                  }
                }}
                inputProps={{
                  min: 0,
                  step: 0.0001
                }}
                disabled={methodPay.TR}
                required
              />
            </GridItem>
          </GridContainer>
        </form>
      </GridItem>
      <GridItem xs={2} style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Button
          key={methodPay.TR}
          form="formTR"
          type="submit"
          color={
            methodPay.TR === false
              ? props.themeContext.buttonColor
              : props.themeContext.buttonColorDanger
          }
          size="sm"
        >
          {methodPay.TR === false ? (
            <>
              <AccountBalanceWallet />
              Agregar
            </>
          ) : (
            <>
              <Close />
              Quitar
            </>
          )}
        </Button>
      </GridItem>
    </>
  );
});
